<div>
  <h1 class="h2">Export {{recordCount}} {{recordCount === 1 ? 'Record' : 'Records'}}</h1>
  <ng-container *ngIf="allowSpecializedExports">
    <div class="qToggle qToggle--primary mt-0100 lh-normal">
      <input class="qToggle__checkbox screen-reader"
             type="checkbox"
             value="standard"
             id="export-type-toggle--standard"
             [checked]="exportTypeUi === 'standard'"
             (change)="exportTypeUi = 'standard'">
      <label class="qToggle__btn col__ col__xs--20"
             for="export-type-toggle--standard">
        <span>Standard Export</span>
      </label>
      <input class="qToggle__checkbox screen-reader"
             type="checkbox"
             value="specialized"
             id="export-type-toggle--specialized"
             [checked]="exportTypeUi === 'specialized'"
             (change)="exportTypeUi = 'specialized'">
      <label class="qToggle__btn col__ col__xs--20"
             for="export-type-toggle--specialized">
        <span>Specialized Export</span>
      </label>
    </div>
  </ng-container>
  <div *ngIf="exportTypeUi === 'standard'">
    <app-export-standard-component (exportSuccess)="exportSuccess.emit($event)"
                                   [query]="query"
                                   [recordCount]="recordCount"></app-export-standard-component>
  </div>

  <app-export-specialized *ngIf="exportTypeUi === 'specialized' && allowSpecializedExports"
                          (exportSuccess)="exportSuccess.emit($event)"
                          [query]="query"
                          [recordCount]="recordCount"></app-export-specialized>

</div>
